// extracted by mini-css-extract-plugin
module.exports = {"Copied":"GistDetails_Copied__1JQKl"};